import { Ref } from 'react';
import { ModalInformation } from '../ModalInformation';
import { Text } from 'native-base';

interface ModalEmployeeNumberProps {
  modalRef: Ref<unknown> | undefined;
}

export const ModalEmployeeNumber = ({ modalRef }: ModalEmployeeNumberProps) => {
  return (
    <ModalInformation headerText="Employee Number" modalRef={modalRef}>
      <Text mt={2}>
        Your employee ID is the unique number your company uses to identify you.
        You can edit your employee ID number under {"'My Account'"} -{' '}
        {"'Profile'"}. Your employee number can be found on your Pay Slip. If
        {" you're"} unsure what it is or where to find it, please reach out to
        your HR representative or volunteer manager.
      </Text>
    </ModalInformation>
  );
};
